import { apiClient } from '@/config/api';
import { BoxType, HydraCollection } from '@/types';

export const boxTypeService = {
  // Get all box types
  async getBoxTypes(): Promise<BoxType[]> {
    const response = await apiClient.get<HydraCollection<BoxType>>('/box_types', {
      params: {
        'groups[]': ['boxType:read'],
      },
    });

    const data = response.data;
    const boxTypes = data['hydra:member'] || data['member'] || [];
    return boxTypes;
  },
};
